import dayjs from "dayjs";
import { useEffect, useState } from "react";

import { useLoader } from "@/contexts/loader";

import { driverServices } from "../driverServices";
import { QueuePositionDriverApi } from "../driverTypes";

export type DriverGetQueuePositionData = {
  data: QueuePositionDriverApi | null;
  isError: boolean;
  isLoading: boolean;
  isDriverActionsBlocked: boolean;
};

/**
 * @property {string} [driverId]
 */
export function useDriverGetQueuePosition(driverId: string): DriverGetQueuePositionData {
  const { isLoading, setLoading } = useLoader();
  const [data, setData] = useState<QueuePositionDriverApi | null>(null);
  const [isDriverActionsBlocked, setIsDriverActionsBlocked] = useState(false);
  const [error, setError] = useState(false);

  async function fetchData() {
    if (!driverId) return;

    setLoading(true);
    try {
      const driverData = await driverServices.getQueuePositionDriver(Number(driverId));
      const queueDate = driverData.queue.date;
      const isDriverActionsBlocked = blockDriverActions({
        appointmentTime: queueDate
      });

      setIsDriverActionsBlocked(isDriverActionsBlocked);
      setData(driverData);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, [driverId]);

  return {
    data,
    isDriverActionsBlocked,
    isError: error,
    isLoading: isLoading
  };
}

function blockDriverActions({ appointmentTime }: { appointmentTime: string }): boolean {
  const now = dayjs();
  const appointment = dayjs(appointmentTime);

  const minutes = appointment.diff(now, "minute");

  const SIX_HOURS_IN_MINUTES = 6 * 60; // 360 min
  const isDriverActionsBlocked = minutes <= SIX_HOURS_IN_MINUTES;
  return isDriverActionsBlocked;
}
